import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateTestbedDialogComponent } from '../create-testbed-dialog/create-testbed-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { map, switchMap, tap } from 'rxjs/operators';
import { EMPTY, forkJoin, merge, Observable, of } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from "@angular/material/sort";
import { TestbedsService } from "../../../services/testbeds.service";
import { Testbed } from "../../../model/testbed";
import { DialogsService } from "../../../services/dialogs.service";
import { SnackService } from "../../../services/snack.service";
import { GeneralItemDetailDialogComponent } from "../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import { Constants } from "../../../utils/constants";
import { AuthService } from "../../../services/auth.service";
import { FileUploadDialogComponent } from '../../storage/file-upload-dialog/file-upload-dialog.component';
import { StorageFile } from '../../../model/storageFile';
import { Contract } from "../../../model/contract";
import { isNumber } from 'lodash-es';
import { HttpClient } from '@angular/common/http';
import { ContractsService } from 'src/app/services/contracts.service';
import { Tester } from 'src/app/model/tester';
import { AddTestersDialogComponent } from '../add-testers-dialog/add-testers-dialog.component';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'aw-list-testbeds',
  templateUrl: './list-testbeds.component.html',
  styleUrls: ['./list-testbeds.component.scss']
})
export class ListTestbedsComponent implements OnInit, AfterViewInit {

  public displayedColumns = [
    'identifier',
    'address',
    'company',
    'action'
  ];

  public readonly customerDoesntSeeColumns: string[] = [
    'company',
  ];

  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  @ViewChild('paginatorTestbeds') paginatorUsers!: MatPaginator;
  @Input() testbed?: Testbed;
  @Input() embeddedLayout = false;
  @Input() contract = null;
  @Input() tester?: Tester;
  dataSource!: MatTableDataSource<Testbed>;
  entities = Constants.entities;
  expandedTestbed?: Testbed;
  expandedTesters?: Testbed;
  selectedTestbedFiles?: StorageFile[];
  roles = Constants.roles;
  contractStatuses = Constants.contractStatuses;
  loggedUser?: any;
  currentContract?: Contract;
  allTestbeds$!: Observable<Testbed[]>;
  upload$?: Observable<any>;

  constructor(
    public dialog: MatDialog,
    private testbedsService: TestbedsService,
    private userService: UsersService,
    private contractService: ContractsService,
    private authService: AuthService,
    private dialogsService: DialogsService,
    private snackService: SnackService,
    private http: HttpClient,
  ) {
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();
  }

  ngAfterViewInit(): void {
    this.allTestbeds$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => {
            //This could be duplicated code, keep in mind you might have to refactor it
            if (isNumber(this.testbed)) {
              return forkJoin([this.testbedsService.getTestbedById(this.testbed as number, true)]);
            }
            ///////////////////////////////////////
            else if (!this.testbed) {
              if (this.tester) {
                return this.testbedsService.getAllTestbedsByTester(this.tester.id);
              }
              else if (this.loggedUser.role === this.roles.admin)
                return this.testbedsService.getAllTestbeds();
              else if (this.loggedUser.role === this.roles.customer || this.loggedUser.role === this.roles.tester) {
                this.displayedColumns = this.displayedColumns.filter(elem => !this.customerDoesntSeeColumns.includes(elem));
                return this.testbedsService.getAllTestbedsByCompany(this.loggedUser.company.id, false);
              }
            }
            else if (this.loggedUser.role !== this.roles.logistic) {
              if (this.loggedUser.role === this.roles.customer)
                return this.testbedsService.getAllTestbedsByCompany(this.loggedUser.company.id, false);
              return this.testbedsService.getTestbedById(this.testbed?.id).pipe(map(value => [value]));
            }
            return of([]);
          }),
          tap(x => {
            this.dataSource = new MatTableDataSource<Testbed>(x);
            this.dataSource.paginator = this.paginatorUsers;
            x.forEach(testbed => {
              testbed.currentContract =
                testbed.contracts?.find(contract =>
                  contract.status === Constants.contractStatuses.new
                  || contract.status === Constants.contractStatuses.approvalWaiting
                  || contract.status === Constants.contractStatuses.testbedAssociation
                  || contract.status === Constants.contractStatuses.boxesWaiting
                  || contract.status === Constants.contractStatuses.ongoing
                  || contract.status === Constants.contractStatuses.extended);
            });

            this.loading = false;
          })
        );
    this.allTestbeds$.subscribe();
  }

  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortTestbeds(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {


      const index: string = event.active;

      if (event.active === 'company') {
        if (event.direction === 'asc') {
          return ('' + b.company?.companyName).localeCompare('' + a.company?.companyName);
        } else {
          return ('' + a.company?.companyName).localeCompare('' + b.company?.companyName);
        }
      }

      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }


    }
    );
  }

  details(testbed: Testbed): void {
    if (testbed.weseth2) {
      // this.http.get<any>('http://localhost:3000/getNetworks').subscribe(response => {

      //   let networks = {}
        
      //   for (let i = 0; i < response.networks.length; i++) {
      //     let key = "network " + i;
      //     networks = {...networks, [key]: response.networks[i].net_name}
      //   }
        
      //   let obj = {...testbed, ...networks};

      //   this.dialog.open(GeneralItemDetailDialogComponent, { data: obj });
      //  });

       this.contractService.getTestbedNetworks(this.contract.id).subscribe(response => {
          
          let networks = {}
        
          for (let i = 0; i < response.data.networks.length; i++) {
            let key = "Bus Type & Communication " + i;
            networks = {...networks, [key]: response.data.networks[i].net_name}
          }
          
          let obj = {...testbed, ...networks};

          this.dialog.open(GeneralItemDetailDialogComponent, { data: obj });
       });
    }
    else
      this.dialog.open(GeneralItemDetailDialogComponent, { data: testbed });
    
  }

  createTestbed(): void {
    this.disabled = true;
    this.dialog
      .open(CreateTestbedDialogComponent, { data: new Testbed() })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allTestbeds$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  editTestbed(testbed: Testbed): void {
    this.disabled = false;
    this.dialog
      .open(CreateTestbedDialogComponent,
        { data: { testbed: testbed, creatingFromContract: false } })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allTestbeds$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  addTesters(testbed: Testbed, contract: Contract): void {
    this.disabled = true;
    console.log(testbed)
    this.dialog
      .open(AddTestersDialogComponent, { data: {testbed: testbed, contract: contract} })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allTestbeds$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  openTestList(): void {
    // let domain = 'http://localhost:4200/reserved/contracts/';
    // window.open(domain + this.contract.id + '/test-list', '_blank');
    // Use router instead of window.open


  }

  openOutputList(): void {
    // let domain = 'http://localhost:4200/reserved/contracts/';
    // window.open(domain + this.contract.id + '/output-list', '_blank');
  }

  deleteTestbed(testbed: Testbed): void {
    this.disabled = true;
    const id = testbed.id ?? -1;
    this.disabledItemId.push(id);
    this.dialogsService
      .confirm('Delete testbed', `Are you sure you want to delete the testbed "${testbed.identifier}"?`)
      .pipe(
        switchMap((value) => value ?
          this.testbedsService.deleteTestbed(testbed.id) : //there was <number>
          EMPTY),
        switchMap(() => this.allTestbeds$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Testbed deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });

  }

  showFiles(elementshowFiles: Testbed): void {
    this.expandedTestbed != elementshowFiles ?
      this.expandedTestbed = elementshowFiles :
      this.expandedTestbed = undefined;

    this.expandedTesters = undefined;

  }

  expandTesters(element: Testbed): void {

    this.expandedTesters != element ?
      this.expandedTesters = element :
      this.expandedTesters = undefined;

    this.expandedTestbed = undefined;

    console.log(this.expandedTesters)
  
  }

  canIAccessTestbedFiles(testbed: Testbed): boolean {

    return this.loggedUser.role === this.roles.admin || this.loggedUser.role === this.roles.customer;
    // FIXME: You should check this, but after lambda refactoring, currentContract is not available at this stage.
    //this.loggedUser.role === this.roles.admin || (testbed.currentContract?.contractReferent?.id === this.loggedUser.id);
  }

  upload(element: Testbed): void {
    this.upload$ = this.dialog
      .open(FileUploadDialogComponent, { data: { testbed: element, files: this.selectedTestbedFiles } })
      .afterClosed();

    this.upload$.subscribe();
  }

}

